import { useGetWorkspaceCodeQuery } from 'hooks/queries/user';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { getCookie, setCookie } from 'utils/cookies';

/** 로그인 페이지 외에 워크스페이스 코드가 쿠키로 저장되어 있지 않은 경우 추가해주는 hook */
const useSetWorkspaceCode = () => {
	const location = useLocation();

	const { data: code_data = null, isLoading: code_loading } = useGetWorkspaceCodeQuery();

	const code_condition = code_data !== null && !code_loading;

	const code = getCookie('imms_workspace_code');

	useEffect(() => {
		if (!location.pathname.includes('/login') && code_condition && code)
			setCookie('imms_workspace_code', code_data.code);
	}, [code, location]);
};

export default useSetWorkspaceCode;
